var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-text-field',{ref:"timeField",attrs:{"slot":"activator","color":"indigo","mask":"time","rules":_vm.timeRules,"value":_vm.value,"label":_vm.label,"prepend-icon":"access_time"},on:{"input":_vm.fieldInput},slot:"activator"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }